import React, { useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const getData = (sensores) => {

    const temperatura = sensores.map(item => item.temperatura);
    const calidad = sensores.map(item => item.calidad);
    const humedad = sensores.map(item => item.humedad);
    const presion = sensores.map(item => item.presion);
    const velocidad = sensores.map(item => item.velocidad);
    const direccion = sensores.map(item => item.direccion);
    const precipitaciones = sensores.map(item => item.precipitaciones);
    const intensidad = sensores.map(item => item.intensidad);
    const hora = sensores.map(item => item.fecha);

    return {
        labels: hora,
        datasets: [
            {
                label: 'Temperature',
                data: temperatura,
                borderColor: 'rgb(220, 20, 60)',
                backgroundColor: 'rgba(220, 20, 60, 0.5)',
            },
            {
                label: 'Quality',
                data: calidad,
                borderColor: 'rgb(65, 105, 225)',
                backgroundColor: 'rgba(65, 105, 225, 0.5)',
            },
            {
                label: 'Humidity',
                data: humedad,
                borderColor: 'rgb(255, 255, 0)',
                backgroundColor: 'rgba(255, 255, 0, 0.5)',
            },
            {
                label: 'Pressure',
                data: presion,
                borderColor: 'rgb(255, 125, 125)',
                backgroundColor: 'rgba(255, 125, 125, 0.5)',
            },
            {
                label: 'Speed',
                data: velocidad,
                borderColor: 'rgb(0, 255, 0)',
                backgroundColor: 'rgba(0, 255, 0, 0.5)',
            },
            {
                label: 'Direction',
                data: direccion,
                borderColor: 'rgb(100, 100, 255)',
                backgroundColor: 'rgba(100, 100, 255, 0.5)',
            },
            {
                label: 'Precipitation',
                data: precipitaciones,
                borderColor: 'rgb(0, 0, 60)',
                backgroundColor: 'rgba(0, 0, 60, 0.5)',
            },
            {
                label: 'Intensity',
                data: intensidad,
                borderColor: 'rgb(100, 100, 0)',
                backgroundColor: 'rgba(100, 100, 0, 0.5)',
            }
        ],
    };
};

const getOptions = () => ({
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Relation meteorological node',
        },
    },
});

const ChartMeteorologico = ({ data, chartId }) => {
    const chartRef = useRef(null);

    return (
        <Line
            id={`chart-${chartId}`}
            key={chartId}
            ref={chartRef}
            data={getData(data)}
            options={getOptions()}
        />
    );
};

export default ChartMeteorologico;
